import {
  pure,
  renderComponent,
  branch,
  compose
} from 'recompose'
import FormControlWrapper from './FormControlWrapper.jsx'
import HorizontalWrapper from './HorizontalWrapper.jsx'

export default compose(
  branch(props => props.horizontal, renderComponent(HorizontalWrapper)),
  pure
)(FormControlWrapper)



// WEBPACK FOOTER //
// ./components/uiLib/FormControlWrapper/index.js